import { render, staticRenderFns } from "./PAddressItem.vue?vue&type=template&id=2b4b8424"
import script from "./PAddressItem.vue?vue&type=script&lang=js"
export * from "./PAddressItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports